import {
  type ButtonClickContext,
  type TabViewContext,
  TrackButtonClickContext,
  TrackTabViewContext,
} from '../wrapper-context.tsx'

export type PharaohTrackingProvidersProps = {
  children?: React.ReactNode
  clickButtonCallback: (clickContext: ButtonClickContext) => void
  viewTabCallback: (viewContext: TabViewContext) => void
}

export function PharaohTrackingProviders({
  children,
  clickButtonCallback,
  viewTabCallback,
}: PharaohTrackingProvidersProps): React.ReactNode {
  return (
    <TrackTabViewContext.Provider value={viewTabCallback}>
      <TrackButtonClickContext.Provider value={clickButtonCallback}>{children}</TrackButtonClickContext.Provider>
    </TrackTabViewContext.Provider>
  )
}
